import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Modal } from "@/components/UI";
import { fmtQty } from "@/lib/products";

const KIND = { consumption: "Tüketim", receipt: "Mal Kabul", adjustment: "Sayım Düzeltme" };
const fmtDate = (s) => (s ? new Date(s).toLocaleString("tr-TR", { dateStyle: "short", timeStyle: "short" }) : "—");

export function MaterialHistoryModal({ material, onClose }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { if (material) { setRows(null); api.get(`/product-materials/${material.id}/movements`).then(setRows).catch(() => setRows([])); } }, [material]);
  if (!material) return null;
  return (
    <Modal open onClose={onClose} title={`Hareket Geçmişi — ${material.name}`} size="lg">
      <div data-testid="material-history-modal">
        {rows === null ? <div className="text-sm text-slate-500">Yükleniyor…</div> : !rows.length
          ? <div className="text-sm text-slate-500" data-testid="material-history-empty">Henüz hareket yok.</div> : (
            <table className="w-full text-xs">
              <thead className="bg-slate-50"><tr>{["Tarih", "Tür", "Miktar", "Önce → Sonra", "Referans", "Kullanıcı"].map((h) => <th key={h} className="text-left px-2 py-1.5">{h}</th>)}</tr></thead>
              <tbody>
                {rows.map((t) => (
                  <tr key={t.id} className="border-t border-slate-100" data-testid={`material-history-row-${t.id}`}>
                    <td className="px-2 py-1.5 whitespace-nowrap">{fmtDate(t.timestamp)}</td>
                    <td className="px-2 py-1.5">{t.reason_label || KIND[t.kind] || t.kind}</td>
                    <td className={`px-2 py-1.5 font-mono font-semibold ${t.qty < 0 ? "text-rose-600" : "text-emerald-700"}`}>{t.qty > 0 ? "+" : ""}{fmtQty(t.qty)}</td>
                    <td className="px-2 py-1.5 font-mono">{t.qty_before != null ? `${fmtQty(t.qty_before)} → ${fmtQty(t.qty_after)}` : "—"}</td>
                    <td className="px-2 py-1.5">{t.description || "—"}</td>
                    <td className="px-2 py-1.5">{t.user_name || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
      </div>
    </Modal>
  );
}
